import React from 'react'

import { Secondary as ButtonInfo } from 'components/base/Button'
import DesktopHelpers from 'helpers/DesktopHelpers'

import BannerBase from './Base'

export default function BannerWindowsUpdatee() {
  const [displayBanner, setDisplayBanner] = React.useState(true)
  if (
    !displayBanner ||
    !DesktopHelpers.isAppDesktop() ||
    DesktopHelpers.isMac() ||
    DesktopHelpers.isElectronWindowsUpdateFixed()
  ) {
    return false
  }
  return (
    <BannerBase onClose={() => setDisplayBanner(false)} closable>
      <div className="flexbox flexbox-align-center">
        <div>
          <span className="font-weight-medium font-size-large">
            Your Slite application failed to automatically update. Please
            download and install our latest version. This new version should
            continue to automatically update in the future.
          </span>
        </div>
        <div className="margin-left-auto flexbox">
          <ButtonInfo
            onClick={() =>
              window.open(
                'https://slite.com/api/desktop/download?platform=windows',
                '_blank'
              )
            }
            size="small"
            className="margin-right-normal"
          >
            Download
          </ButtonInfo>
        </div>
      </div>
    </BannerBase>
  )
}
